import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { ALL_PLAYER_BLOCKING_TYPES, BLOCKING_TYPE_LABELS } from '../../types/playerBlockingTypes';
import { PanelItem } from '../panelItem';
export const PlayerBlockingStatusPanelItemsContainer = ({ playerInfo }) => {
    const blockingTypes = ALL_PLAYER_BLOCKING_TYPES.filter((blockingType) => playerInfo.blockingTypes.includes(blockingType));
    return (_jsx(_Fragment, { children: blockingTypes.map((blockingType) => (_jsx(PanelItem, { children: _jsx(IconWithLabelDisplay, { icon: _jsx(DoDisturbOnRoundedIcon, {}), label: `You are blocking ${BLOCKING_TYPE_LABELS[blockingType]}`, isAlert: true }) }, blockingType))) }));
};
